<template>
  <div>
    <v-container class="pt-0">
      <span class="headline">DevTools</span>

      <v-row v-if="$tenant.advertising.type == 'adspirit'">
        <v-col cols="12">
            <ins class="asm_async_creative" style="display:block; text-align:left; text-decoration:none;" data-asm-cdn="cdn.adspirit.de" data-asm-host="bfv.adspirit.de" data-asm-responsive="1" data-asm-params="pid=14&gdpr_consent=[consentstring]"></ins>
            <v-btn @click="initAdSpirit()">
              Init AdSpirit
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-btn @click="reload">
            <v-icon left>mdi-reload</v-icon>Reload page
          </v-btn>
          <v-btn @click="createTestLog">
            <v-icon left>mdi-bug</v-icon>Create test log
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-select
            v-model="testNotification"
            :items="['error','warning','info','success']"
            label="Notification"
          />
          <v-btn @click="notify">Trigger notification</v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-btn id="upload-image-test">Image upload with preview</v-btn>
        </v-col>
        <image-upload-with-preview :triggerId="'#upload-image-test'" :uploadAction="getUploadImagePromise"/>
      </v-row>

      <v-row v-if="$store.state.isLoggedIn">
        <v-col cols="12">
          <v-btn @click="openDummySubcription">Open dummy subscription</v-btn>
          <v-btn @click="purchaseDummyArticle">Purchase dummy article</v-btn>
          <v-btn @click="openPremiumDialog">Open Premium dialog</v-btn>
          <v-btn @click="openCoinsDialog">Open Coins dialog</v-btn>
          <v-btn @click="openOnlineIdsDialog">Open Online-IDs dialog</v-btn>
          <v-btn @click="navigateToProfile">Navigate to profile</v-btn>
          <v-btn @click="authAgainstWeb">Authenticate against web-interface</v-btn>
          <v-btn @click="checkWebGuard">Web-interface auth check</v-btn>
          <v-btn @click="openWebUserInfoExternal">Open web user auth info external</v-btn>
          <v-btn @click="logoutFromWebGuard">Logout from web-interface</v-btn>
          <v-btn @click="openPayoutDialog">Payout Dialog</v-btn>
          <payout-dialog v-if="showPayoutDialog" :visible="showPayoutDialog" :closeAction="function() {showPayoutDialog = false}"/>
          <v-btn @click="commonError1">Raise Error to $common</v-btn>
          <v-btn @click="commonError2">Raise APIError to $common</v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn @click="openGoogle"><v-icon left>mdi-open-in-app</v-icon>Open Google (ext)</v-btn>
          <v-btn @click="openGoogle2"><v-icon left>mdi-open-in-app</v-icon>Open Google (blank Window)</v-btn>
          <v-btn @click="openUserCountryDialog"><v-icon left>mdi-map-marker</v-icon>Open User Country dialog</v-btn>
          <v-btn @click="openCoinsDialog" v-if="$store.state.isLoggedIn"><v-icon left>mdi-circle-multiple-outline</v-icon>Open Coins dialog</v-btn>
          <v-btn @click="callAPINonExisting"><v-icon left>mdi-bug</v-icon>Call non-existing API endpoint</v-btn>
          <v-btn @click="callAPIBad"><v-icon left>mdi-bug</v-icon>Call API endpoint as bad request</v-btn>
          <v-btn @click="callAPIWrong"><v-icon left>mdi-bug</v-icon>Call API endpoint with wrong method</v-btn>
          <v-btn @click="callAPI500"><v-icon left>mdi-bug</v-icon>Call API endpoint with server error</v-btn>
        </v-col>
      </v-row>
      
      <v-row>
        <v-col>
          <year-select v-model="selectedYear"/>
        </v-col>
        <v-col>
          <year-select :value="1999"/>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <game-select v-model="selectedGame" :placeholder="'Standard für jedes Spiel'" :hint="'Auswählen um die Online-ID für ein bestimmtes Spiel festzulegen'"/>
        </v-col>
        <v-col>
          <game-select v-model="selectedGame2" :rules="validationRules.required"/>
        </v-col>
      </v-row>

      <v-row v-if="$store.state.nativeApp.ready">
        <v-col cols="12">
          <h2 class="ma4">Native App</h2>
          <span>Device: {{$store.state.nativeApp.type}}</span>
          <p
            style="white-space: pre-wrap;word-break:break-all;padding-left:0.5em;"
          >{{nativeAppInfo}}</p>
        </v-col>
      </v-row>
      <h2 class="ma2">Tenant Data</h2>
      <span style="word-break:break-all;">{{JSON.stringify($tenant)}}</span>
      <h2 class="ma2">(App Dataset)</h2>
      <span style="word-break:break-all;">{{JSON.stringify(appDataset)}}</span>
      <h2 class="ma2">Info</h2>
      <p>Letztes ServiceWorker Update: {{lastServiceWorkerUpdate}}</p>
      <h2>Logs</h2>
      <v-row v-for="(entry, index) in logs" :key="index">
        <v-col cols="3" class="ma-0 pa-1 pl-3">
          <span>{{new Date(entry.createdAt).toLocaleString()}}</span>
        </v-col>
        <v-col cols="9" class="ma-0 pa-1">{{entry.message}}</v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import appDataset from "@/plugins/appDataset.js";
import { MUTATION_LOG } from "@/plugins/store.js";
import {
  MUTATION_RAISE_NOTIFICATION,
  MUTATION_PERFORM_SUBSCRIPION,
  MUTATION_SHOW_PREMIUM_DIALOG,
  MUTATION_SHOW_COINS_DIALOG,
  MUTATION_SHOW_ONLINE_IDS_DIALOG,
  MUTATION_SHOW_USER_COUNTRY_DIALOG,
} from "@/plugins/store";

import { EVENT_EXT_NATIVE_APP_READY, EVENT_NAVIGATE_TO } from "@/plugins/eventbus";
import ImageUploadWithPreview from "@/widgets/ImageUploadWithPreview";
import purchaseProduct from "@/mixins/purchaseProduct";
import PayoutDialog from '@/widgets/payout/PayoutDialog.vue';
import YearSelect from '@/widgets/YearSelect.vue';
import GameSelect from '@/widgets/GameSelect.vue';

export default {
  name: "DevTools",
  mixins: [purchaseProduct],
  components: {
    ImageUploadWithPreview,
    PayoutDialog,
    YearSelect,
    GameSelect,
  },

  data: function() {
    return {
      testNotification: undefined,
      purchaseData: undefined,
      showPayoutDialog: false,
      appDataset: appDataset,
      selectedYear: undefined,
      selectedGame: undefined,
      selectedGame2: 'fifa',
      validationRules: {
          required: [v => !!v || this.$t('common.mandatory-field')],
      }
    }
  },
  mounted() {
    this.$eventBus.$on(EVENT_EXT_NATIVE_APP_READY, this.onNativeAppReady);
  },
  beforeDestroy() {
    this.$eventBus.$off(EVENT_EXT_NATIVE_APP_READY, this.onNativeAppReady);
  },
  computed: {
    logs() {
      let logs = this.$store.state.log.content;
      return logs.slice().reverse();
    },
    lastServiceWorkerUpdate() {
      let ret = this.$store.state.serviceWorker.lastUpdateDate;
      return ret ? new Date(ret).toLocaleString() : "-";
    },
    nativeAppInfo() {
      var ret = "";
      if (window.espocial && window.espocial.native) {
        ret += "(native js-context available)\n";
        if (this.$store.state.nativeApp.notificationsEnabled !== undefined) {
          ret +=
            "Notifications " +
            (this.$store.state.nativeApp.notificationsEnabled
              ? "granted"
              : "declined") +
            "\n";
        } else {
          ret += "Notifications state unknown\n";
        }
        if (this.$store.state.nativeApp.pushToken !== undefined) {
          ret +=
            'Push Token: "' + this.$store.state.nativeApp.pushToken + '"\n';
        } else {
          ret += "No push token available\n";
        }
        if (window.espocial.native.log) {
          ret += "log func available\n";
        }
        if (window.espocial.native.alert) {
          ret += "alert func available\n";
        }
        if (window.espocial.native.requestPushToken) {
          ret += "requestPushToken func available\n";
        }
      } else {
        ret += "window.espocial.native js-context missing\n";
      }
      return ret;
    },
  },
  methods: {
    reload() {
      location.reload();
    },
    createTestLog() {
      this.$store.commit(MUTATION_LOG, "Test-Log");
    },
    notify() {
      this.$store.commit(MUTATION_RAISE_NOTIFICATION, {
        type: this.testNotification,
        message: `I am a test notification of type ${this.testNotification}`,
      });
    },
    openGoogle() {
      this.$common.openExternalLink("https://google.de?q=eSpocial")
    },
    openGoogle2() {
      this.$common.openBlankWindow("https://google.de?q=eSpocial");
    },
    openDummySubcription() {
      this.$store.commit(MUTATION_PERFORM_SUBSCRIPION, {
        name: "Dummiplan",
        plan: "dummy",
        description: "Lebenslanger Dummiplan",
        cost: "0.01",
        url: "https://useplink.com/de/",
      });
    },
    purchaseDummyArticle() {
      this.purchaseProduct('dummy');
    },
    openPremiumDialog() {
      this.$store.commit(MUTATION_SHOW_PREMIUM_DIALOG);
    },
    openCoinsDialog() {
      this.$store.commit(MUTATION_SHOW_COINS_DIALOG);
    },
    openOnlineIdsDialog() {
      this.$store.commit(MUTATION_SHOW_ONLINE_IDS_DIALOG);
    },
    openUserCountryDialog() {
      this.$store.commit(MUTATION_SHOW_USER_COUNTRY_DIALOG);
    },
    navigateToProfile() {
      this.$eventBus.$emit(EVENT_NAVIGATE_TO, '/profile');
    },
    authAgainstWeb() {
      this.$api
        .authenticateAgainstWebGuard()
        .then(response => {
          let name = response.data.name
          this.$store.commit(MUTATION_RAISE_NOTIFICATION, {
            type: 'success',
            message: `Authenticated successfully as "${name}" against web guard`,
          });
          console.log('Profile', response.data)
        })
        .catch(error => {
          console.log(error)
          this.$common.onError(error)
        })
    },
    logoutFromWebGuard() {
      this.$api
        .logoutFromWebGuard()
        .then(() => {
          this.$store.commit(MUTATION_RAISE_NOTIFICATION, {
            type: 'success',
            message: `Successfully logged out from web guard`,
          });
        })
        .catch(error => {
          console.log(error)
          this.$common.onError(error)
        })
    },
    checkWebGuard() {
      this.$api
        .getProfileViaWebGuard()
        .then(response => {
          let name = response.data.name
          this.$store.commit(MUTATION_RAISE_NOTIFICATION, {
            type: 'success',
            message: `Authenticated successfully as "${name}" against web guard`,
          });
          console.log('Profile', response.data)
        })
        .catch(error => {
          console.log(error)
          this.$common.onError(error)
        })
    },
    openWebUserInfoExternal() {
      this.$common.openExternalLink('/auth/web/info')
    },
    callAPINonExisting() {
      this.$http.get("/api/wrong-endpoint");
    },
    callAPIBad() {
      this.$http.post("/api/gameinstances/creationCheck");
    },
    callAPIWrong() {
      this.$http.get("/api/gameinstances/creationCheck");
    },
    callAPI500() {
      this.$http.post("/api/dev/error");
    },
    onNativeAppReady() {
      this.$store.commit(MUTATION_RAISE_NOTIFICATION, {
        type: "success",
        message: `Native app is ready`,
      });
    },
    openPayoutDialog() {
      this.showPayoutDialog = true;
    },
    getUploadImagePromise(formData) {
      return new Promise((resolve) => {
        window.setTimeout(() => {
          console.log(formData)
          this.notify();
          resolve()
        }, 1500)        
      });
    },
    initAdSpirit() {
      window.asm_async_data.initi()
    },
    commonError1() {
      this.$common.onError(new Error('Iam any error'));
    },
    commonError2() {
      this.$common.onError(new this.$api.APIError('Iam an APIError'));
    }
  },
};
</script>
